import React from 'react';

import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

const OwnerWorkspaceIntroPanel: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const messages = processing_activities_messages.asset_ropa.owner_workspace;

  return (
    <section className={styles.introPanel}>
      <div>
        <Typography className={styles.introEyebrow} variant='overline'>
          {t(messages.intro.eyebrow)}
        </Typography>
        <Typography gutterBottom variant='h3'>
          {t(messages.intro.title)}
        </Typography>
        <Typography color='textSecondary' variant='body2'>
          {t(messages.intro.body)}
        </Typography>
      </div>
      <span className={styles.ownerViewBadge}>{t(messages.intro.owner_badge)}</span>
    </section>
  );
};

export default OwnerWorkspaceIntroPanel;
